// NÃO UTILIZAR ESSA STORE EM CÓDIGO NOVO!
// Essa store é apenas utilizada pela TableLegacy

import { create } from "zustand";

interface PageStore {
  pageState: Record<string, number>; // Dicionário para armazenar a página atual de cada tabela
  setCurrentPage: (tableName: string, page: number) => void;
  getCurrentPage: (tableName: string) => number;
  reset: () => void;
}

const usePageStore = create<PageStore>((set, get) => ({
  pageState: {},
  setCurrentPage: (tableName, page) =>
    set((state) => ({
      pageState: {
        ...state.pageState,
        [tableName]: page,
      },
    })),
  getCurrentPage: (tableName) => get().pageState[tableName] || 1,
  reset: () => set({ pageState: {} }),
}));

export default usePageStore;
